import React from "react";
import { CONTACT_FORM_URL, GOOGLE_FORM_URL } from "./AppConstant";

const WebDevelopment = () => {
  return (
    <div className="container-fluid py-5 bg-white">
      <div className="container">
        <div className="row align-items-center g-5">
          {/* Image Section */}
          <div className="col-lg-6 order-lg-2 wow fadeInRight" data-wow-delay="0.3s">
            <img
              className="img-fluid rounded"
              src="https://assets.zyrosite.com/Aq20eV79zLfpXV6b/bb375cdd655184ca2715ac5059e73651-YX4ZEeZEvbhrMMZa.gif"
              alt="Web Development"
            />
          </div>
          {/* Text Section */}
          <div className="col-lg-6 order-lg-1 wow fadeInLeft" data-wow-delay="0.6s">
            <h2 className="mb-4 text-primary">Professional Web Development</h2>
            <p className="mb-4">
              At <strong>Aesos</strong>, we craft responsive, fast, and secure websites that not only look stunning but also drive results. Whether you need a landing page, corporate website, or full-fledged web application — we deliver it with performance and precision.
            </p>
            <ul className="list-unstyled mb-4">
              <li><i className="fa fa-check-circle text-secondary me-2"></i>Custom Website Design & Development</li>
              <li><i className="fa fa-check-circle text-secondary me-2"></i>E-commerce & CMS Platforms</li>
              <li><i className="fa fa-check-circle text-secondary me-2"></i>SEO & Speed Optimization</li>
              <li><i className="fa fa-check-circle text-secondary me-2"></i>Ongoing Support & Maintenance</li>
            </ul>
            <a href='/contact' className="btn btn-primary px-4 py-2">
              contact
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WebDevelopment;
